import React from "react";
import { motion } from "framer-motion";

import { FaMugHot, FaShoppingBag, FaCheckCircle } from "react-icons/fa";
import { GiCoffeeBeans, GiCoffeeCup } from "react-icons/gi";
import { MdLocalCafe } from "react-icons/md";

const timelineData = [
  {
    id: 1,
    icon: <GiCoffeeBeans className="text-amber-950 w-5 h-5" />,
    title: "قهوه تازه رُست شده چیست؟",
    description:
      "وقتی صحبت از قهوه می‌شود، همه ما به دنبال همان عطر و طعم بی‌نظیری هستیم، که با اولین جرعه، روزمان را پرانرژی کند. راز این تجربه در تازگی رُست قهوه نهفته است.",
  },
  {
    id: 2,
    icon: <MdLocalCafe className="text-amber-900 w-5 h-5" />,
    title: "قهوه رُست شده چیست؟",
    description:
      "دانه‌های قهوه در ابتدا سبز رنگ و بدون عطر هستند. فرآیند رُست باعث تغییر رنگ، بو و طعم می‌شود و قندها کاراملی و روغن‌های معطر آزاد می‌شوند. به همین دلیل است که بعد از رُست، دانه قهوه تازه بوی بسیار قوی و خوشایندی دارد.",
  },
  {
    id: 3,
    icon: <FaMugHot className="text-amber-800 w-5 h-5" />,
    title: "چرا تازگی مهم است؟",
    description:
      "قهوه درست مثل نان تازه است؛ هرچه زمان بیشتری از رُست آن بگذرد، عطر و طعمش کاهش پیدا می‌کند.۱ تا ۱۴ روز بعد از رُست: بهترین زمان مصرف. ۲ تا ۴ هفته بعد: بخشی از عطر از دست می‌رود. بیش از یک ماه: طعم تخت و تلخ می‌شود.",
  },
  {
    id: 4,
    icon: <GiCoffeeCup className="text-amber-700 w-5 h-5" />,
    title: "تفاوت قهوه تازه با قدیمی",
    description:
      "قهوه تازه: عطر قوی، طعم پیچیده، کرمای طلایی. قهوه قدیمی: بوی ماندگی، طعم تلخ یکنواخت و بدون کرما.",
  },
  {
    id: 5,
    icon: <FaShoppingBag className="text-amber-600 w-5 h-5" />,
    title: "چطور قهوه تازه بخریم؟",
    description: (
      <>
        تاریخ رُست روی بسته را بررسی کنید. از تأمین‌کننده‌های معتبر مثل{" "}
        <strong>خورشید جاده ابریشم</strong> خرید کنید که قهوه‌ها را تازه و اصولی رُست می‌کنند. 
        به جای خرید زیاد، دوره‌ای قهوه تازه تهیه کنید.
      </>
    ),},
  {
    id: 6,
    icon: <FaCheckCircle className="text-amber-500 w-5 h-5" />,
    title: "جمع‌بندی",
    description:
      "قهوه تازه رُست شده تجربه‌ای بی‌نظیر با عطر قوی‌تر، طعم خوشایندتر و کیفیت بالاتر است که هر عاشق قهوه باید امتحان کند.",
  },
];

export const CoffeeFreshPage = () => {
  return (
    <div className="relative max-w-3xl mx-auto pt-28 px-4">

      {/* Vertical line */}
      <div className="absolute left-1/2 top-32 bottom-0 rounded  w-1 -translate-x-1/2 bg-gray-200"></div>

      <div className="space-y-12 relative mb-10">
        {timelineData.map((item, index) => (
          <motion.div
            key={item.id}
            initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
            className={`flex items-center gap-6 ${
              index % 2 === 0 ? "flex-row-reverse text-right" : ""
            }`}
          >
            {/* Text */}
            <div className="w-1/2">
              <h3 className="text-lg font-semibold text-amber-900">{item.title}</h3>
              <p className="text-sm text-stone-700 mt-2 leading-relaxed text-justify">
                {item.description}
              </p>
            </div>

            {/* Icon circle */}
            <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white border-2 border-gray-300 shadow-md relative z-10">
              {item.icon}
            </div>

            {/* Empty spacer */}
            <div className="w-1/2"></div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default CoffeeFreshPage;
